// FEInlineActionsXL - Sprint 44 Fase 3 Vista 4.
// Reemplazo XL de FEInlineActions legacy. Tokens, dark mode, botones XL.
// Reusa FEStatusBadge (ya XL) y el hook useFacturaElectronica existente.
// No toca backend ni service. Solo UI.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../design/motion';
import FEStatusBadge from './FEStatusBadge';
import useFacturaElectronica from './hooks/useFacturaElectronica';

const CSS_ID = 'xl-fe-inline-css';
const CSS = `
.xl-fe-inline {
  display: inline-flex; align-items: center; gap: 8px; flex-wrap: wrap;
  font-family: var(--xl-font-sans);
}
.xl-fe-inline__btn {
  font: 500 13px/1 var(--xl-font-sans);
  padding: 9px 14px;
  border-radius: var(--xl-radius-md);
  border: 1px solid transparent;
  cursor: pointer;
  transition: background 120ms cubic-bezier(0,0,0.2,1),
              border-color 120ms cubic-bezier(0,0,0.2,1);
}
.xl-fe-inline__btn:focus-visible { outline: 2px solid var(--xl-color-focus); outline-offset: 2px }
.xl-fe-inline__btn:disabled { opacity: 0.45; cursor: not-allowed }

.xl-fe-inline__btn--primary {
  background: var(--xl-color-success);
  color: var(--xl-color-text-inverse);
}
.xl-fe-inline__btn--primary:hover { filter: brightness(1.08) }

.xl-fe-inline__btn--warn {
  background: var(--xl-color-warning);
  color: var(--xl-color-text-inverse);
}
.xl-fe-inline__btn--warn:hover { filter: brightness(1.08) }

.xl-fe-inline__btn--ghost {
  background: transparent;
  color: var(--xl-color-text-secondary);
  border-color: var(--xl-color-border);
}
.xl-fe-inline__btn--ghost:hover {
  background: var(--xl-color-surface-alt);
  color: var(--xl-color-text);
}

.xl-fe-inline__btn--link {
  background: transparent;
  color: var(--xl-color-info);
  border-color: rgba(37,99,235,0.32);
}
.xl-fe-inline__btn--link:hover {
  background: rgba(37,99,235,0.08);
}
[data-xl-theme="dark"] .xl-fe-inline__btn--link {
  border-color: rgba(96,165,250,0.32);
}
[data-xl-theme="dark"] .xl-fe-inline__btn--link:hover {
  background: rgba(96,165,250,0.14);
}

.xl-fe-inline__msg {
  font-size: 12px;
  color: var(--xl-color-danger);
  font-style: italic;
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`;

export default function FEInlineActionsXL({ ventaId, disabled }) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);

  const { fe, loading, enviar, reenviar, verXml, verPdf } =
    useFacturaElectronica(ventaId);

  if (!ventaId) return null;

  const est = fe && fe.estado;
  const puedeEnviar = !fe || est === 'pendiente';
  const puedeReenviar = est === 'rechazado';
  const tieneXml = !!(fe && fe.xml_path);
  const tienePdf = !!(fe && fe.pdf_path);

  return (
    <div className="xl-fe-inline" role="group" aria-label="Acciones Factura Electronica">
      <FEStatusBadge fe={fe} />

      {puedeEnviar && (
        <button type="button"
          className="xl-fe-inline__btn xl-fe-inline__btn--primary"
          onClick={enviar}
          disabled={loading || disabled}
        >
          {loading ? 'Enviando\u2026' : 'Enviar a DIAN'}
        </button>
      )}

      {puedeReenviar && (
        <button type="button"
          className="xl-fe-inline__btn xl-fe-inline__btn--warn"
          onClick={reenviar}
          disabled={loading || disabled}
        >
          {loading ? 'Reenviando\u2026' : 'Reenviar a DIAN'}
        </button>
      )}

      {tieneXml && (
        <button type="button"
          className="xl-fe-inline__btn xl-fe-inline__btn--ghost"
          onClick={verXml}
        >
          Ver XML
        </button>
      )}

      {tienePdf && (
        <button type="button"
          className="xl-fe-inline__btn xl-fe-inline__btn--link"
          onClick={verPdf}
        >
          Ver PDF FE
        </button>
      )}

      {fe && fe.mensaje_respuesta && est === 'rechazado' && (
        <span className="xl-fe-inline__msg" title={fe.mensaje_respuesta}>
          {fe.mensaje_respuesta}
        </span>
      )}
    </div>
  );
}
